// src/redux/reducers/cityReducer.js
import {
    FETCH_GETQUALIFICATION_FAILURE,
    FETCH_GETQUALIFICATION_REQUEST,
    FETCH_GETQUALIFICATION_SUCCESS, 
    SET_SELECTED_GETQUALIFICATION 
  } from '../types'; 
  
  const initialState = {
    loading: false,
    qualficationList: [],
    selectedqualficationId: null, 
    error: null,
  };
  
  const qualificationReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_GETQUALIFICATION_REQUEST:
        return { ...state, loading: true };
      case FETCH_GETQUALIFICATION_SUCCESS:
        return { ...state, loading: false, qualficationList: action.payload };
      case FETCH_GETQUALIFICATION_FAILURE:
        return { ...state, loading: false, error: action.payload };
      case SET_SELECTED_GETQUALIFICATION:
        return { ...state, selectedqualficationId: action.payload };
      default:
        return state;
    }
  };
  
  export default qualificationReducer;

  